<template>
  <div class="module">
    <div class="module__title"></div>
    <div class="module__content">
      <div class="scroll">
        <div ref="scrollContent" class="scroll__content">
          <div ref="scrollText" class="text">{{ description }}</div>
          <div ref="horizontalScrollbar" class="scrollbar">
            <div class="indicator"></div>
          </div>
        </div>
      </div>
      <div class="swiper-box">
        <div class="swiper" id="characterSwiper">
          <div class="swiper-wrapper">
            <div
              v-for="(item, key) in characterData"
              :key="key"
              class="swiper-slide swiper-no-swiping"
            >
              <img :src="item.img" />
            </div>
          </div>
          <div class="swiper-pagination">
            <div
              v-for="(item, key) in characterData"
              :key="key"
              class="swiper-pagination__btn"
              :class="{ active: swiper.activeIndex == key }"
            >
              <img :src="swiper.activeIndex == key ? item.avatar_active : item.avatar_inactive" />
            </div>
          </div>
        </div>
        <div ref="doorBox" class="door-box">
          <div class="door left"></div>
          <div class="door right"></div>
        </div>
        <div ref="cloudBox" class="cloud-box">
          <div class="cloud cloud-1"></div>
          <div class="cloud cloud-2"></div>
          <div class="cloud cloud-3"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import characterMixins from '@/mixins/home/characterMixins.js'

export default {
  name: 'PcHomeCharacter',
  mixins: [characterMixins],
}
</script>

<style lang="scss" scoped>
.module {
  height: 1233px;

  &__title {
    background-position: center -768px;
  }

  &__content {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    margin-top: 50px;
    width: 1344px;
    height: 750px;
  }
}

.scroll {
  position: absolute;
  top: 50%;
  left: 44px;
  transform: translateY(-50%);
  width: 458px;
  height: 411px;
  background: url('~@/assets/img/pc/scroll_bg.png') no-repeat;

  &__content {
    position: absolute;
    left: 128px;
    top: 55px;
    overflow: hidden;
    width: 144px;
    height: 314px;
    
    .text {
      height: 288px;
      text-indent: 36px;
      line-height: 24px;
      text-align: justify;
      font-size: 16px;
      font-family: Noto Serif SC;
      font-weight: bold;
      color: #441f0e;
      letter-spacing: 2px;
      writing-mode: vertical-lr;
      cursor: pointer;
    }

    .scrollbar {
      position: absolute;
      bottom: 0;
      width: 144px;
      height: 26px;
      border-radius: 2px;

      &::before {
        content: '';
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        width: 100%;
        height: 3px;
        background-color: #b37c5a;
      }

      .indicator {
        position: relative;
        z-index: 1;
        width: 37px;
        height: 26px;
        background: url('~@/assets/img/pc/scroll_arrow.png') no-repeat;
        cursor: pointer;
        animation: 1.5s fadeInAndOut linear infinite;
      }
    }
  }
}

@keyframes fadeInAndOut {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}

.swiper-box {
  position: absolute;
  left: 352px;
  width: 750px;
  height: 750px;
  background: url('~@/assets/img/common/character_bg.png') no-repeat;
}

.swiper {
  overflow: visible;

  ::v-deep .swiper-slide {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 750px;
    height: 750px;

    img {
      opacity: 0;
      height: 600px;
    }
  }
  ::v-deep .swiper-slide-active {
    img {
      animation: .5s characterfadeIn .5s linear forwards;
    }
  }

  ::v-deep .swiper-pagination {
    position: absolute;
    left: initial;
    right: -172px;
    width: 195px;
    height: 692px;
    background: url('~@/assets/img/pc/avatar_bg.png') no-repeat;

    .swiper-pagination__btn {
      position: absolute;
      width: 154px;
      height: 145px;
      cursor: pointer;

      &.active::after {
        content: '';
        position: absolute;
        left: 0;
        bottom: 0;
        width: 178px;
        height: 59px;
        background: url('~@/assets/img/common/avatar_active.png') no-repeat;
      }

      img {
        width: 100%;
        height: 100%;
      }

      &:nth-of-type(1) {
        top: 0;
        left: 20px;
      }
      &:nth-of-type(2) {
        top: 174px;
        left: 113px;
      }
      &:nth-of-type(3) {
        top: 374px;
        left: 113px;
      }
      &:nth-of-type(4) {
        top: 539px;
        left: 20px;
      }
    }
  }
}

.door-box {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: block;
  overflow: hidden;
  width: 650px;
  height: 650px;
  border-radius: 50%;

  .door {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 343px;
    height: 647px;
    background: url('~@/assets/img/common/door.png') no-repeat;
  }

  .left {
    left: -17px;
  }

  .right {
    right: -17px;
    background-position: -343px 0;
  }

  &.animation {
    .left {
      animation: .8s openLeftDoor linear forwards;
    }

    .right {
      animation: .8s openRightDoor linear forwards;
    }
  }
}

@keyframes openLeftDoor {
  0% {
    left: -17px;
  }
  100% {
    left: -245px;
  }
}

@keyframes openRightDoor {
  0% {
    right: -17px;
  }
  100% {
    right: -245px;
  }
}

.cloud-box {
  position: absolute;
  left: 50%;
  bottom: -8px;
  transform: translateX(-50%);
  z-index: 1;
  width: 822px;
  height: 300px;

  .cloud {
    position: absolute;
    opacity: 0;
  }

  .cloud-1 {
    right: 0;
    bottom: 10px;
    width: 519px;
    height: 290px;
    background: url('~@/assets/img/common/cloud1.png') no-repeat;
  }

  .cloud-2 {
    left: 25px;
    bottom: 40px;
    width: 504px;
    height: 201px;
    background: url('~@/assets/img/common/cloud2.png') no-repeat;
  }

  .cloud-3 {
    left: 0;
    bottom: 0;
    width: 548px;
    height: 165px;
    background: url('~@/assets/img/common/cloud3.png') no-repeat;
  }

  &.animation {
    .cloud-1 {
      animation: 1s cloud1 .2s linear forwards;
    }
    .cloud-2 {
      animation: .7s cloud2 .4s linear forwards;
    }
    .cloud-3 {
      animation: .6s cloud3 .6s linear forwards;
    }
  }
}

@keyframes cloud1 {
  0% {
    right: 100px;
    bottom: 10px;
    opacity: 0;
    transform: scale(.8);
  }
  100% {
    right: 0;
    bottom: 10px;
    opacity: 1;
    transform: scale(1);
  }
}
@keyframes cloud2 {
  0% {
    left: 125px;
    bottom: 40px;
    opacity: 0;
    transform: scale(.8);
  }
  100% {
    left: 25px;
    bottom: 40px;
    opacity: 1;
    transform: scale(1);
  }
}
@keyframes cloud3 {
  0% {
    left: 100px;
    bottom: 0;
    opacity: 0;
    transform: scale(.8);
  }
  100% {
    left: 0;
    bottom: 0;
    opacity: 1;
    transform: scale(1);
  }
}
</style>
